import { internalApi } from "@circle-react/helpers/urlHelpers";
import { keepPreviousData, useQuery, useQueryClient } from "react-query";

import type { PostFilters } from "@/react/components/SettingsApp/Posts/FiltersBar";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";

import { RESULTS_PER_PAGE } from "../constants";
import { orderParam } from "../PostsTable/sortHelpers";
import type { PostsOrder } from "../PostsTable/types";

const REQUEST_KEY = ["settings", "posts"];

export interface UsePostsApiProps {
  filter: PostFilters;
  order?: PostsOrder;
  page?: number;
}
export const usePostsApi = ({ page = 1, filter, order }: UsePostsApiProps) => {
  const fetchPosts = async () =>
    reactQueryGet(
      internalApi.settings.posts.index({
        params: {
          filter,
          page,
          per_page: RESULTS_PER_PAGE,
          ...orderParam(order),
        },
      }),
    );

  const {
    data,
    isPending: isLoadingPosts,
    refetch: refetchPosts,
  } = useQuery({
    queryKey: [...REQUEST_KEY, filter, page, order],
    queryFn: fetchPosts,
    placeholderData: keepPreviousData,
  });

  return {
    posts: data?.records ?? [],
    postsCount: data?.count ?? 0,
    isLoadingPosts,
    refetchPosts,
  };
};

export const useInvalidatePostsApiQueries = () => {
  const queryClient = useQueryClient();

  const invalidatePostsApiQueries = () =>
    queryClient.invalidateQueries({ queryKey: REQUEST_KEY });

  return { invalidatePostsApiQueries };
};
